module.exports = __webpack_public_path__ + "static/larry-page-5eca3b66709d1a5a418fbe4adbb52147.jpg";